export default __webpack_public_path__ + "static/telefon-8529f1d0253be805c7632d019db73b09.png";